import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns, faUsers, faFileLines, faArrowRightFromBracket, faSpellCheck, faChartLine, faHospital, faDiagramProject } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../hooks/AuthContext';
import Tooltip from './ToolTip';
import { useEffect, useState } from 'react';
import { faRProject } from '@fortawesome/free-brands-svg-icons';
import { canViewKpiPages, isKpiOnlyAccount } from '../utils/access';

function SideBar() {
    const { logout } = useAuth();
    const [role, setRole] = useState(localStorage.getItem('role')?.trim());
    const [showKpiTabs, setShowKpiTabs] = useState(canViewKpiPages());
    const [kpiOnly, setKpiOnly] = useState(isKpiOnlyAccount());
    useEffect(() => {
        const storedRole = localStorage.getItem('role')?.trim();
        setRole(storedRole);
        setShowKpiTabs(canViewKpiPages());
        setKpiOnly(isKpiOnlyAccount());
    }, []);

    return (
        <div className="bg-gray-800 h-full p-3 relative me-1">
            <ul className="space-y-4">
                {!kpiOnly &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Dashboard" placement="tooltip-right">
                            <a href="/dashboard?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("dashboard") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faTableColumns} className={`text-xl ${window.location.href.includes("dashboard") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {!kpiOnly && (role === '1' || role === '2' || role === '4' || role === '5') &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Account Management" placement="tooltip-right">
                            <a href="/roles?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("roles") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faUsers} className={`text-xl ${window.location.href.includes("roles") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {!kpiOnly && (role === '1' || role === '2' || role === '4' || role === '6' || role === '7'|| role === '8') &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Configurator" placement="tooltip-right">
                            <a href="/configurator?page=1" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("configurator") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faFileLines} className={`text-xl ${window.location.href.includes("configurator") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {!kpiOnly && (role === '1' || role === '7') &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Text Enhancer" placement="tooltip-right">
                            <a href="/TextEnhancer" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("TextEnhancer") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faSpellCheck} className={`text-xl ${window.location.href.includes("TextEnhancer") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {!kpiOnly && (role === '7') &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="3D Repo" placement="tooltip-right">
                            <a href="/3drepo" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 ${window.location.href.includes("3drepo") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faRProject} className={`text-xl ${window.location.href.includes("3drepo") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {showKpiTabs &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="KPI Dashboard" placement="tooltip-right">
                            <a href="/kpi-dashboard" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("kpi-dashboard") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faChartLine} className={`text-xl ${window.location.href.includes("kpi-dashboard") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {showKpiTabs &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="Clinics" placement="tooltip-right">
                            <a href="/clinics" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("clinics") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faHospital} className={`text-xl ${window.location.href.includes("clinics") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
                {
                    showKpiTabs &&
                    <li className='w-full h-full'>
                        <Tooltip tooltipText="SE Project Creation" placement="tooltip-right">
                            <a href="/se_project_creation" className={`flex items-center justify-center p-2 text-base font-normal hover:text-blue-500 rounded-lg text-white hover:bg-gray-700 w-full ${window.location.href.includes("se_project_creation") ? "bg-gray-700" : "bg-gray-200"}`}>
                                <FontAwesomeIcon icon={faDiagramProject} className={`text-xl ${window.location.href.includes("se_project_creation") ? "text-blue-500" : "text-blue-400"}`} />
                            </a>
                        </Tooltip>
                    </li>
                }
            </ul>
            <ul className='absolute bottom-0 left-0 space-y-2 px-3 py-4 w-full'>
                <Tooltip tooltipText="Logout" placement="tooltip-right">
                    <li onClick={logout} className="flex cursor-pointer items-center p-2 text-base font-normal rounded-lg hover:text-blue-500 text-white hover:bg-gray-700 bg-gray-200">
                        <FontAwesomeIcon icon={faArrowRightFromBracket} className={`text-xl rotate-180 text-blue-400`} />
                    </li>
                </Tooltip>
            </ul>
        </div>
    );
}

export default SideBar;